"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const MarketplaceBase_1 = __importDefault(require("./MarketplaceBase"));
class Marketplace extends MarketplaceBase_1.default {
}
module.exports = Marketplace;
